// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rot[data-v-2a525b9f]{-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);-o-transform:rotate(90deg);transform:rotate(90deg)}.tag[data-v-2a525b9f]{background:var(--bg-alter-2);border:var(--border-1);border-radius:4px;font-size:10px;line-height:12px;padding:4px}.indicator[data-v-2a525b9f]{background:var(--disabled-indicator);border-radius:50%;height:6px;width:6px}.indicator.in-range[data-v-2a525b9f]{background:var(--access-indicator)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
